import React from 'react';
import { FAQData } from '@mockData/FAQData';
import AccordionItem from '@shared/Features/FAQSection/FAQItem/FAQItem';
import styles from './FAQSection.module.css';

const FAQSection: React.FC = () => {
    return (
        <section className={styles.faqSection}>
            <h3 className={styles.faqSectionName}>
                How to calculate your bill of materials using our templates
            </h3>
            <div className={styles.faqContainerContent}>
                {FAQData.map((item, index) => (
                    <AccordionItem
                        key={index}
                        question={item.question}
                        answer={item.answer}
                    />
                ))}
            </div>
        </section>
    );
};

export default FAQSection;
